// behavior 行为统计
import httpRequest from './request'
import apiConfig from '@/config'
import store from '@/store'
const behavior = function({ name = '', behavior_code }) {
  // httpRequest.post(apiConfig.sendBehavior, { campaign: store.state.campaign, channel: store.state.channel, name, behavior_code })
}
export { behavior }



// WEBPACK FOOTER //
// ./src/utils/behavior.js